import { Chrome, Download, ShieldCheck } from "lucide-react";
import { Later, Primary, Sheet, VisualStep } from "@/components/install/ui";

export const chromeIntent = () => {
  const u = new URL(window.location.href);
  u.searchParams.set("instalar", "1");
  const fallback = encodeURIComponent("https://play.google.com/store/apps/details?id=com.android.chrome");
  return `intent://${u.host}${u.pathname}${u.search}#Intent;scheme=https;package=com.android.chrome;S.browser_fallback_url=${fallback};end`;
};

export const ChromeGuide = ({ onClose }) => (
  <Sheet title="Instálala segura con Chrome" onClose={onClose} testId="install-chrome-guide">
    <p className="mt-3 text-slate-600">Este navegador la instala con un formato antiguo y Android la bloquea. Con Chrome es segura y verificada por Google.</p>
    <ol className="mt-5 space-y-5">
      <VisualStep n="1" icon={<Chrome size={28} />}>Toca <b>Abrir en Chrome</b></VisualStep>
      <VisualStep n="2" icon={<Download size={28} />} red>Toca <b>Instalar</b> y listo</VisualStep>
    </ol>
    <a href={chromeIntent()} className="block" data-testid="install-open-chrome">
      <Primary as="span"><Chrome size={24} />Abrir en Chrome</Primary>
    </a>
    <p className="mt-3 flex items-center justify-center gap-1.5 text-sm text-slate-500"><ShieldCheck size={16} className="text-[#3D88B8]" />Sin avisos de Play Protect</p>
    <Later onClick={onClose} data-testid="install-chrome-later" />
  </Sheet>
);

export const NoPromptGuide = ({ onClose }) => (
  <Sheet title="Instálala desde el menú" onClose={onClose} testId="install-menu-guide">
    <ol className="mt-6 space-y-5">
      <VisualStep n="1" icon={<span className="text-3xl font-black leading-none">⋮</span>}>Toca el menú <b>⋮</b> arriba a la derecha</VisualStep>
      <VisualStep n="2" icon={<Download size={28} />} red>Toca <b>Instalar app</b> o <b>Añadir a pantalla de inicio</b></VisualStep>
    </ol>
    <Primary onClick={onClose} data-testid="install-menu-ok">Entendido</Primary>
  </Sheet>
);
